export enum GENERATE_REPORT_BUSINESS_ERRORS {
  'REPORTS_LIMIT_REACHED' = 'REPORTS_LIMIT_REACHED',
  'PENDING_REPORTS_LIMIT_REACHED' = 'PENDING_REPORTS_LIMIT_REACHED'
}
